import { render, staticRenderFns } from "./Bugs.vue?vue&type=template&id=737df00b"
import script from "./Bugs.vue?vue&type=script&lang=ts"
export * from "./Bugs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports